import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import 'rxjs/add/operator/map';
import * as _ from 'lodash';
import { MatSnackBar } from '@angular/material';
import { FuseConfigService } from '../../../../../core/services/config.service';
import { fuseAnimations } from '../../../../../core/animations';

import { ProNavigationModel } from '../../../../../navigation/proNavigation.model';
import { FuseNavigationService } from '../../../../../core/components/navigation/navigation.service';
import { FuseTranslationLoaderService } from '../../../../../core/services/translation-loader.service';
import { locale as navigationEnglish } from '../../../../../navigation/i18n/en';
import { locale as navigationTurkish } from '../../../../../navigation/i18n/tr';

//Query File
import { UserQueryService } from '../../gql-query-mutation/index';

/**Local file */
import { spekwo, toastMsg, login, resetPwd } from '../../utils/index';

/** Local component */
import { ToastComponent } from '../../../../../core/components/toast/toast.component';

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    animations: fuseAnimations
})

export class LoginComponent implements OnInit {
    loginForm: FormGroup;
    loginFormErrors: any;
    isResults = false;
    hide = true;
    spekwoValues: any = {};
    toastMsg: any = {};
    loginValues: any = {};
    resetPwdValues = resetPwd;

    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        public snackBar: MatSnackBar,
        private fuseConfig: FuseConfigService,
        private fuseNavigationService: FuseNavigationService,
        private translate: TranslateService,
        private translationLoader: FuseTranslationLoaderService,
        /** Queery file */
        public userQueryService: UserQueryService,

        private _toastComponent: ToastComponent,
    ) {

        this.fuseConfig.setSettings({
            layout: {
                toolbar: 'none',
                footer: 'none'
            }
        });

        this.loginFormErrors = {
            username: {},
            password: {}
        };
        // Add languages
        this.translate.addLangs(['en', 'tr']);

        // Set the default language
        this.translate.setDefaultLang('en');

        // Use a language
        this.translate.use('en');
        this.translationLoader.loadTranslations(navigationEnglish, navigationTurkish);

        this.spekwoValues = spekwo;
        this.toastMsg = toastMsg;
        this.loginValues = login;

    }

    ngOnInit() {

        this.loginForm = this.formBuilder.group({
            username: ['', [Validators.required, Validators.email]],
            password: ['', Validators.required]
        });

        this.loginForm.valueChanges.subscribe(() => {
            this.onLoginFormValuesChanged();
        });

    }

    ngOnDestroy() {
    }

    // On login form changes
    onLoginFormValuesChanged() {

        for (const field in this.loginFormErrors) {

            if (field == 'username') {
                this.loginForm.value.username = this.loginForm.value.username.trim().toLowerCase()
            }

            if (!this.loginFormErrors.hasOwnProperty(field)) {
                continue;
            }

            // Clear previous errors
            this.loginFormErrors[field] = {};

            // Get the control
            const control = this.loginForm.get(field);

            if (control && control.dirty && !control.valid) {
                this.loginFormErrors[field] = control.errors;
            }

        }
    }

    // Trim space while typing 
    emailChange() {
        this.loginForm.get('username').setValue(this.loginForm.value.username.trim());
    }

    //after login
    login() {

        this.isResults = true;

        this.userQueryService.LOGIN(this.loginForm.value)
            .valueChanges
            .subscribe(({ data }) => {

                if (data && data.allUsers && data.allUsers.edges.length > 0) {
                    /** Based on role set navigation  */
                    if (data.allUsers.edges[0].node.roleByRoleId.roleName === this.spekwoValues.Pro) {

                        // Set the navigation model
                        this.fuseNavigationService.setNavigationModel(new ProNavigationModel());

                        setTimeout(() => {
                            this.router.navigate(['apps/home']);
                        }, 10);

                        window.localStorage.setItem("userUID", data.allUsers.edges[0].node.userId);
                        window.localStorage.setItem("role", data.allUsers.edges[0].node.roleByRoleId.roleName);

                        this._toastComponent.showToast(this.toastMsg.loginSuccess)

                    } else {
                        this._toastComponent.showToast(this.toastMsg.loginFailed)
                    }

                    this.isResults = false;
                }
                else {

                    this._toastComponent.showToast(this.toastMsg.loginInvalid)
                    this.isResults = false;

                }
            }, () => {

                this._toastComponent.showToast(this.toastMsg.networkError)
                this.isResults = false;

            })
    }

}



// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/authentication/login/login.component.ts